<template>
	<div class="mb-4" :style="rowStyle" @click="handleRowClick" :class="{ 'is-disabled': disabled }">
		<div class="flex-space-between--center">
			<div>
				<div class="reg" :style="{ color: optionColor, fontSize: optionFontSize }">
					<span>{{ optionName }}</span>
				</div>
			</div>
			<div class="text-right" style="height: 22px">
				<AppSwitch v-model="localSwitch" class="swtch drk mr-n4 sml" @click.stop inset dense color="white" hide-details />
			</div>
		</div>
		<div v-if="!!description" class="subtle-message font-size-xs">
			{{ description }}
		</div>
	</div>
</template>

<script>
export default {
	name: 'SwitchOption',
	props: {
		switchModel: { type: Boolean },
		optionName: { type: String },
		description: { type: String },
		optionColor: { type: String },
		optionFontSize: { type: String },
		clickAnywhere: { type: Boolean, default: true },
		disabled: { type: Boolean },
	},
	watch: {
		switchModel: {
			handler(newV) {
				this.localSwitch = newV;
			},
			immediate: true,
		},
		localSwitch: {
			handler(newV) {
				this.$emit('update:switchModel', newV);
			},
		},
	},
	data() {
		return {
			localSwitch: false,
		};
	},
	computed: {
		rowStyle() {
			const style = {};
			if (this.clickAnywhere) {
				style['cursor'] = 'pointer';
			}
			return style;
		},
	},
	methods: {
		handleRowClick() {
			if (this.clickAnywhere) {
				this.localSwitch = !this.localSwitch;
			}
		},
	},
};
</script>
